import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * The analysis section renders no content of its own, so landing on `/surveys`
 * opens its first tab. Matching handles the "exactly /surveys" part — this route
 * is reached only for that path, never for the tabs below it.
 */
export const Route = createFileRoute('/_client/_auth/surveys/')({
    beforeLoad: () => {
        // `replace` keeps this out of history — otherwise going back from a tab
        // lands here and immediately redirects forward again.
        throw redirect({ to: '/surveys/summaries', replace: true });
    },
});
